import React from "react";

const CustomCarouselNextBtn: React.FC = () => {
  return (
    <div className="custom-carousel-control next">
      <span className="carousel-control-next-icon" />
    </div>
  );
};

export default CustomCarouselNextBtn;
